import { alpha } from "@mui/material/styles";

// ----------------------------------------------------------------------

// SETUP COLORS
const GREY = {
  0: "#FFFFFF",
  100: "#F9FAFB",
  200: "#F4F6F8",
  300: "#DFE3E8",
  400: "#C4CDD5",
  500: "#919EAB",
  600: "#637381",
  700: "#454F5B",
  800: "#040404",
  900: "#161C24",
};

const PRIMARY = {
  lighter: "#B7F4D1", // Lighter green shade
  light: "#6FDB9B", // Light green shade
  main: "#0CAF60", // Primary green
  dark: "#088848", // Darker green shade
  darker: "#066735", // Even darker green
  contrastText: "#FFFFFF", // White for contrast
};

const SECONDARY = {
  lighter: "#4B5563", // Lighter navy/gray shade
  light: "#374151", // Light navy/gray shade
  main: "#111827", // Dark navy (main)
  dark: "#0D121D", // Darker shade
  darker: "#090E16", // Even darker shade
  contrastText: "#FFFFFF", // White for better contrast
};

const TERTIARY = {
  lighter: "#7986AC", // Lighter blue-gray shade
  light: "#4D5F87", // Light blue-gray
  main: "#212C45", // Deep blue-gray
  dark: "#1A2337", // Darker blue-gray
  darker: "#141B2A", // Even darker blue-gray
  contrastText: "#FFFFFF", // White for contrast
};

const INFO = {
  lighter: "#8BB0FF",
  light: "#5289FF",
  main: "#1861FF",
  dark: "#1249BF",
  darker: "#0C3180",
  contrastText: "#FFFFFF",
};

const SUCCESS = {
  lighter: "#8DD8AC",
  light: "#53C483",
  main: "#01AD2C",
  dark: "#148543",
  darker: "#0D582C",
  contrastText: GREY[800],
};

const WARNING = {
  lighter: "#FFE083",
  light: "#FFD145",
  main: "#FFC107",
  dark: "#BF9105",
  darker: "#806103",
  contrastText: GREY[800],
};

const ERROR = {
  lighter: "#FF8F8F",
  light: "#FF5656",
  main: "#FF1E1E",
  dark: "#BF1616",
  darker: "#800F0F",
  contrastText: "#FFFFFF",
};

const palette = {
  mode: "light",
  common: {
    black: "#000000",
    white: "#FFFFFF",
    grey: "#8B8B8B",
    greyLight: "#B3B3B3",
    light: "#FFF2E3",
  },
  primary: PRIMARY,
  secondary: SECONDARY,
  tertiary: TERTIARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: alpha(GREY[500], 0.24),
  text: {
    primary: GREY[800],
    secondary: GREY[600],
    disabled: GREY[500],
  },
  background: {
    paper: "#fff",
    default: "#FFF",
    neutral: GREY[200],
  },
  action: {
    active: GREY[600],
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default palette;
